import { createElement } from "react";
import { cx } from "./cx";
import { ICONS, type IconName } from "./icon-set";

export type { IconName };

/** One icon from the redesign's set, drawn at the size the surrounding style gives `svg.i` (18 px by default). */
export function Icon({ name, fill = false, className }: { name: IconName; fill?: boolean; className?: string }) {
  return (
    <svg className={cx("i", fill && "fill", className)} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {ICONS[name].map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs }))}
    </svg>
  );
}
